import { gsap } from "gsap";

gsap.config({
  force3D: false,
  nullTargetWarn: false,
});

gsap.defaults({
  ease: "power1.out",
});

export const preAnimate = () => {
  setDefaults();
  const master = gsap.timeline();
  master.add(
    showElements([
      ".invet .challenge .hero__content",
      ".invet .challenge .animation-btn",
    ])
  );
  return master;
};

function setDefaults() {
  gsap.set(".invet .invetSlideLeft", {
    x: 600,
    scale: 0.8,
    transformOrigin: "bottom",
  });
  gsap.set(".invet .invetRobot", {
    y: 225,
  });
  gsap.set([".invet .invetRobotPortalTop", ".invet .invetRobotPortalBottom"], {
    scaleX: 0,
    x: 40,
  });
  gsap.set(".invet .invetRobotMask", {
    y: 225,
  });
  gsap.set(".invet .invetPhone", {
    y: 500,
  });
  gsap.set(".invet .invetPhoneMask", {
    y: 490,
  });
  gsap.set([".invet .invetPhonePortalTop", ".invet .invetPhonePortalBottom"], {
    scaleX: 0,
    x: 135,
  });
  gsap.set(".invet .invetTruck", {
    x: -160,
  });
}

export const afterAnimate = () => {
  gsap.set(".invet .challenge__content", {
    autoAlpha: 1,
    visibility: "visible",
    y: 0,
  });
  gsap.set(".invet .invetSlideLeft", {
    x: 0,
    scale: 1,
  });
  gsap.set(".invet .invetRobot", {
    y: 0,
  });
  gsap.set([".invet .invetRobotPortalTop", ".invet .invetRobotPortalBottom"], {
    scaleX: 1,
  });
  gsap.set(".invet .invetPhone", {
    y: 0,
  });
  gsap.set(".invet .invetSlideRight", {
    autoAlpha: 0,
    visibility: "hidden",
  });
  gsap.set(".invet .invetRobotHand", {
    rotate: 0,
  });
  gsap.set([".invet .invetPhonePortalTop", ".invet .invetPhonePortalBottom"], {
    scaleX: 0,
  });
};

const master = gsap.timeline({
  paused: true,
});
export const animation = (setIsFinished) => {
  master
    .add(moveItem(".invet .invetTruck", 0))
    .add(rotateWheels(".invet .invetTruckWheel", 270), "<")
    .add(
      portalOpenAnimation([
        ".invet .invetRobotPortalTop",
        ".invet .invetRobotPortalBottom",
      ]),
      "+=0.1"
    )
    .add(showItemAnimation(".invet .invetRobot"))
    .add(
      portalCloseAnimation([
        ".invet .invetRobotPortalTop",
        ".invet .invetRobotPortalBottom",
      ]),
      "+=0.2"
    )
    .add(portalCloseAnimation(".invet .invetRobotMask", 0, 0.2), "<")

    .add(robotHandAnimation(".invet .invetRobotHand", -50))
    .add(
      portalOpenAnimation(
        [".invet .invetPhonePortalTop", ".invet .invetPhonePortalBottom"],
        1,
        0.7
      ),
      "-=0.2"
    )
    .add(showItemAnimation(".invet .invetPhone"))
    .add(
      portalCloseAnimation(
        [".invet .invetPhonePortalTop", ".invet .invetPhonePortalBottom"],
        0,
        0.4
      ),
      "+=0.1"
    )
    .add(robotHandAnimation(".invet .invetRobotHand", -30, true, 1, 0.1))
    .add(moveItem(".invet .invetTruck", "100%", 1))
    .add(rotateWheels(".invet .invetTruckWheel", 540, 1), "<")
    .add(robotHandAnimation(".invet .invetRobotHand", 0))
    .add(moveItem(".invet .invetSlideLeft", 0, 1), "<")
    .add(
      portalCloseAnimation(
        [".invet .invetRobotPortalTop", ".invet .invetRobotPortalBottom"],
        1,
        1
      ),
      "<"
    )
    .add(hideContent(".invet .challenge .hero__content", -50), "<")
    .add(
      hideContent([".invet .invetSlideRight", ".invet .invetTruckRoad"]),
      "<"
    )
    .add(showContent(".invet .challenge .challenge__content"), "<")
    .to(".invet .challenge .animation-btn", {
      autoAlpha: 0,
      opacity: 0,
      duration: 0.2,
      onComplete: () => {
        setIsFinished(true);
      },
    });
  return master;
};

function showElements(selectors, duration = 0) {
  const tl = gsap.timeline();
  tl.to(selectors, { autoAlpha: 1, opacity: 1, duration });
  return tl;
}

function moveItem(selector, x, duration = 0.5) {
  const tl = gsap.timeline();
  tl.to(selector, { x, y: 0, scale: 1, duration: duration });
  return tl;
}

function rotateWheels(selector, deg, duration = 0.5) {
  const tl = gsap.timeline();
  tl.to(selector, {
    rotate: deg,
    duration,
    transformOrigin: "center",
  });
  return tl;
}

function portalOpenAnimation(
  selector,
  scale = 2.3,
  duration = 0.3,
  delay = 0.1
) {
  const tl = gsap.timeline();
  tl.to(selector, {
    scaleX: scale,
    y: 0,
    duration,
    delay,
    transformOrigin: "center",
  });
  return tl;
}

function portalCloseAnimation(selector, scaleX = 0.8, duration = 0.2) {
  const tl = gsap.timeline();
  tl.to(selector, {
    scaleX,
    duration,
  });
  return tl;
}

function showItemAnimation(selector, duration = 0.5) {
  const tl = gsap.timeline();
  tl.to(selector, { y: 0, duration });
  return tl;
}

function robotHandAnimation(
  selector,
  deg,
  yoyo = false,
  repeat = 0,
  duration = 0.2
) {
  const tl = gsap.timeline();
  tl.to(selector, { rotate: deg, duration, yoyo, repeat });
  return tl;
}

function hideContent(selector, yPercent = 0) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 0, opacity: 0, yPercent, duration: 0.5 });
  return tl;
}

function showContent(selector) {
  const tl = gsap.timeline();
  tl.to(selector, { autoAlpha: 1, opacity: 1, y: 0, duration: 0.5 });
  return tl;
}
